import React from 'react';
import AsyncPage from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default [
  <BlankLayout
    key="/perfectbeauty/skincarepro/terms-of-service"
    exact
    path="/perfectbeauty/skincarepro/terms-of-service"
    component={AsyncPage}
  />,
];
